import { supportedChains } from './chains';
import { getDefaultConfig } from '@rainbow-me/rainbowkit';

// WalletConnect project ID (get from https://cloud.walletconnect.com)
// For production, you MUST set VITE_WALLETCONNECT_PROJECT_ID environment variable
const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || 'demo-project-id';

// Check if using demo project ID and log warning
if (projectId === 'demo-project-id') {
  console.warn('⚠️ Using demo WalletConnect project ID. Wallet connection features may be limited.');
  console.warn('⚠️ To enable full functionality, set VITE_WALLETCONNECT_PROJECT_ID in your Vercel environment variables.');
  console.warn('⚠️ Get a project ID from: https://cloud.walletconnect.com');
}

// Use RainbowKit's getDefaultConfig which includes Rainbow Wallet and other popular wallets
// Support all chains: Ethereum, Arbitrum One, and ApeChain
export const config = getDefaultConfig({
  appName: 'Wallet Analysis Service',
  projectId: projectId, // RainbowKit requires a project ID, even if demo
  chains: supportedChains as any,
  ssr: false, // Disable SSR for better compatibility
});
